import $ from 'jquery';

class ModalShareButtons {
    /**
     * The ModalShareButtons class hijacks the share buttons from a post page
     * and provides an interface for updating their URLS
     * @param  {string} originalUrl the url of the original string
     * @return {obj} instance of ModalShareButtons
     */
    constructor(originalUrl) {
        this.$shareModal = $('.share-modal-content');
        this.startHref = originalUrl;
        this.encodedStartHref = encodeURIComponent(this.startHref);
        this.$shareButtons = this.$shareModal.find('[class^="share-link-"]');
    }

    // Get the URL of the current post
    getCurrentURI() {
        return window.location.href;
    }

    // Update the share URL to the current slide's URL
    updateShareURIs(currURI, newURI) {
        $.each(this.$shareButtons, (index, domEl) => {
            let $item = $(domEl);
            let href =  $item.attr('href');
            $item.attr('href', href.replace(currURI, newURI));
        });
    }

    // Call updateShareURIs
    restoreShareURIs() {
        this.updateShareURIs(this.updatedURI, this.encodedStartHref);
    }

    // Create the modal with the current slide URL and jquery modal settings we need
    shareModalClick() {
        this.updatedURI = encodeURIComponent(this.getCurrentURI());
        this.updateShareURIs(this.encodedStartHref, this.updatedURI);
        this.$shareModal.modal({
            closeExisting: false,
            escapeClose: true,
            clickClose: true,
            closeClass: '.close-modal',
            modalClass: 'modal',
            spinnerHtml: null,
            showSpinner: true,
            showClose: true,
            fadeDuration: null,
            fadeDelay: 1.0
        });
    }
}

export default ModalShareButtons;
